var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBarChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 24H9.2C8.0799 24 7.51984 24 7.09202 24.218C6.71569 24.4097 6.40973 24.7157 6.21799 25.092C6 25.5198 6 26.0799 6 27.2V38.8C6 39.9201 6 40.4802 6.21799 40.908C6.40973 41.2843 6.71569 41.5903 7.09202 41.782C7.51984 42 8.07989 42 9.2 42H18M18 42H30M18 42L18 17.2C18 16.0799 18 15.5198 18.218 15.092C18.4097 14.7157 18.7157 14.4097 19.092 14.218C19.5198 14 20.0799 14 21.2 14H26.8C27.9201 14 28.4802 14 28.908 14.218C29.2843 14.4097 29.5903 14.7157 29.782 15.092C30 15.5198 30 16.0799 30 17.2V42M30 42H38.8C39.9201 42 40.4802 42 40.908 41.782C41.2843 41.5903 41.5903 41.2843 41.782 40.908C42 40.4802 42 39.9201 42 38.8V9.2C42 8.0799 42 7.51984 41.782 7.09202C41.5903 6.71569 41.2843 6.40973 40.908 6.21799C40.4802 6 39.9201 6 38.8 6H33.2C32.0799 6 31.5198 6 31.092 6.21799C30.7157 6.40973 30.4097 6.7157 30.218 7.09202C30 7.51984 30 8.0799 30 9.2V16",
    stroke: "#01758C",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChart);
export default __webpack_public_path__ + "static/media/bar-chart.bd6be700b0051db8c49bf8453ea6ac4a.svg";
export { ForwardRef as ReactComponent };